import '../vendor/toastr/toastr.min.js';

globalThis.toastr = window.toastr;
